import React from "react"
import Layout from "../../components/layout"
import { GatsbyImage } from "gatsby-plugin-image"
import Seo from "../../components/seo"
import { graphql } from "gatsby"
import Team from "../../components/team"
import Testimonials from "../../components/testimonials"
import Kontakt from "../../components/kontakt"
import Line from "../../images/line.svg"

const AboutPage = ({ data }) => (
  <Layout>
    <Seo title="Über uns" />
    <div className="uber-hero ueber-uns-hero">
      <GatsbyImage
        image={data.contentfulUberUns.image.gatsbyImageData}
        className="ueber-uns-img"
      />
      <div className="uber-headline">
        <h1>{data.contentfulUberUns.title}</h1>
        <img className="line" src={Line} alt="Trennlinie"></img>
      </div>
      <div
        style={{ fontFamily: "BullettoKilla" }}
        className="uber-slogan"
        dangerouslySetInnerHTML={{
          __html: data.contentfulUberUns.slogan.childMarkdownRemark.html,
        }}
      ></div>
    </div>

    <h1
      style={{
        fontVariant: "small-caps",
        fontFamily: "Eczar",
        textTransform: "initial",
        fontWeight: "500",
      }}
      className="reise-headline"
    >
      Über uns
    </h1>

    <section
      className="reise-beschreibung-background"
      style={{ marginTop: "90px", paddingTop: "45px" }}
    >
      <div className="reise-beschreibung-container">
        <div className="float-right">
          <Kontakt
            title="Kontakt"
            tel={data.contentfulUberUns.tel}
            oeffnungszeiten={data.contentfulUberUns.oeffnungszeiten ?? null}
            email={data.contentfulUberUns.email}
            text={data.contentfulUberUns.standort.childMarkdownRemark.html}
          />
        </div>
        <div className="reise-beschreibung">
          <div
            className="reise-beschreibung-text"
            dangerouslySetInnerHTML={{
              __html:
                data.contentfulUberUns.unserePhilosophie.childMarkdownRemark
                  .html,
            }}
          ></div>
        </div>
      </div>
    </section>
    <Team />
    {/* <Testimonials entries={data.contentfulUberUns.testimonials} /> */}
  </Layout>
)

export const query = graphql`
  {
    contentfulUberUns(
      id: { eq: "aaa3ff82-4e52-5f45-8416-75b2e077bac6" }
      childContentfulUberUnsStandortTextNode: { childMarkdownRemark: {} }
    ) {
      title
      unserePhilosophie {
        childMarkdownRemark {
          html
        }
      }
      tel
      email
      standort {
        childMarkdownRemark {
          html
        }
      }
      slogan {
        childMarkdownRemark {
          html
        }
      }
      testimonials {
        name
        id
        text {
          childMarkdownRemark {
            html
          }
        }
      }
      tel
      oeffnungszeiten
      email
      standort {
        childMarkdownRemark {
          html
        }
      }
      image {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`

export default AboutPage
